import { render, staticRenderFns } from "./ProdutosListaAdm.vue?vue&type=template&id=bfa4fd08&scoped=true&"
import script from "./ProdutosListaAdm.vue?vue&type=script&lang=js&"
export * from "./ProdutosListaAdm.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosListaAdm.vue?vue&type=style&index=0&id=bfa4fd08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa4fd08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
